/**
 * Bulk product cataloch for CLS-FI.
 * Mock data — no backend. Keyed by slug.
 *
 * NOTE (placeholder): reuses ABC-SE product images until CLS-specific
 * photography is available.
 */
import bulkFest from '../../../../assets/abc-se/accessories/party-overall.jpg';
import bulkVogn from '../../../../assets/abc-se/accessories/standard-overall.jpg';

export const BULK_PRODUCTS = {
  partyoverallen: {
    slug: 'partyoverallen',
    name: 'Juhlahaalari',
    price: '159 €',
    priceRaw: 159,
    description:
      'Klassinen haalari 100 % puuvillaa piilonapituksella. Erityisesti värjäykseen sopiva. Piilonapitus edessä. Kaksi etutaskua. Oikeassa taskussa vetoketju. Sääntötasku oikeassa lahkeessa. Läppätasku vasemmassa lahkeessa. Säädettävä kuminauha vyötäröllä. Lenkit vyötäröllä. Vahvistettu lenkki oikeassa lahkeessa.',
    images: [
      { src: bulkFest, alt: 'Juhlahaalari' },
    ],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    minPerSize: 0,
    minTotal: 10,
  },
  flakoverallen: {
    slug: 'flakoverallen',
    name: 'Vaunuhaalari',
    price: '159 €',
    priceRaw: 159,
    description:
      'Kestävä standardihaalari, joka on suunniteltu vaunukulkueisiin ja ulkoaktiviteetteihin. 100 % puuvillaa vahvistetuilla saumoilla, säädettävä vyötärö, useita taskuja ja klassinen opiskelijailme. Täydellinen pohja värjäykseen ja yksilöintiin.',
    images: [
      { src: bulkVogn, alt: 'Vaunuhaalari' },
    ],
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    minPerSize: 0,
    minTotal: 10,
  },
};

export const getBulkProduct = (slug) => BULK_PRODUCTS[slug] ?? null;
